import { GeneralModel } from "./general.model";

export class CashFlowModel extends GeneralModel {
}